import { render, staticRenderFns } from "./OpenMultipositionPopup.vue?vue&type=template&id=aa8c9314&scoped=true"
import script from "./OpenMultipositionPopup.vue?vue&type=script&lang=ts"
export * from "./OpenMultipositionPopup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8c9314",
  null
  
)

export default component.exports